import React, { useContext, useEffect, useMemo } from 'react'
import { Alert } from 'reactstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { convertTimestampToDate, convertTimestampToTime, formatAmount, getUserRole, hasAccess } from '../../helper/function'
import { SpinnerContext } from '../../context/spinnerContext'
import { errorToast, successToast } from '../../util/Toast/toast'
import { acknowledgeCleaningCancelRequest, getScheduleCompleteDetails, getSchedulePropertyDataById } from '../../redux/slices/propertySlice'
import CleaningPlacePhoto from '../../component/cleaning/cleanPlacePhoto'

const CancelModalContent = ({ data, finalAmount, onClose }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  const { scheduledPropertiesComplete } = useSelector((state) => state.property)
  const { properties, next_checkin_time, booking_date_time, property_schedule_id, booking_status, cancellation_charge } = data

  const viewLogVisiable = useMemo(() => !location?.pathname?.includes('view-logs'), [location])

  const isCleanningCancelByCleaner = useMemo(() => booking_status === 'canceled cleaner', [booking_status])

  const cleaningCancelRequestShow = useMemo(() => isCleanningCancelByCleaner && cancellation_charge == null, [booking_status, cancellation_charge])

  const onRedirectViewLog = () => {
    onClose()
    navigate(`/view-logs/${property_schedule_id}`)
  }

  useEffect(() => {
    if (isCleanningCancelByCleaner) {
      getPropertyDetails(property_schedule_id)
    }
  }, [isCleanningCancelByCleaner])

  // const overFun = useMemo(() => {
  //   return next_checkin_time
  //     ? checkIfPastDate(next_checkin_time, false)
  //     : checkIfPastDate(booking_date_time, true)
  // }, [booking_date_time, next_checkin_time])
  const overFun = false

  const onAcknowledgeCleaningCancel = async (isChargeCancellation) => {
    if (!scheduledPropertiesComplete?.cleaningData?.cleaning_id) {
      return
    }
    const payload = {
      cleaning_id: scheduledPropertiesComplete?.cleaningData?.cleaning_id,
      isChargeCancellation: isChargeCancellation
    }
    changeLoader(true)
    dispatch(acknowledgeCleaningCancelRequest(payload))
      .then((response) => {
        if (response?.payload?.status === 200) {
          successToast(response?.payload?.data?.status_message || 'Success!')
          getPropertyData(property_schedule_id)
        } else {
          errorToast(response?.payload?.data?.status_message || 'Failed!')
        }
      })
      .catch((err) => {
        errorToast(err?.message || 'Failed!')
      })
      .finally(() => {
        changeLoader(false)
      })
  }

  const getPropertyData = async (schedule_id) => {
    changeLoader(true)
    try {
      dispatch(getSchedulePropertyDataById(schedule_id))
    } catch (err) {
      console.error('Error fetching property data:', err)
    } finally {
      changeLoader(false)
    }
  }

  const getPropertyDetails = async (schedule_id) => {
    changeLoader(true)
    await dispatch(getScheduleCompleteDetails(schedule_id))
      .then(() => {
        changeLoader(false)
      })
      .catch(() => {
        changeLoader(false)
      })
  }

  return (
    <div className="modal-cancel">
      {isCleanningCancelByCleaner && cancellation_charge !== null && (
        <div className="form-header">
          <Alert color="warning">
            {cancellation_charge
              ? 'The cancellation requested by the cleaner has been approved'
              : 'The cancellation requested by the cleaner has been declined'}
          </Alert>
        </div>
      )}
      <div className="common_card_div status-div">
        <h6 className="mb-2">{properties?.property_name}</h6>
        <h6 className={`mb-2 ${!overFun ? '' : 'check-time-over'}`}>
          Checkout:{' '}
          <span>
            {booking_date_time ? (
              <>
                <span>{convertTimestampToDate(booking_date_time)}</span> <span>-</span> <span>{convertTimestampToTime(booking_date_time)}</span>
              </>
            ) : (
              '--'
            )}
          </span>
        </h6>
        <h6 className="mb-0">
          Next Check-In:{' '}
          <span>
            {next_checkin_time ? (
              <>
                <span>{convertTimestampToDate(next_checkin_time)}</span> <span>-</span> <span>{convertTimestampToTime(next_checkin_time)}</span>
              </>
            ) : (
              '--'
            )}
          </span>
        </h6>
      </div>
      <div className="common_card_div status-div">
        <h6 className="mb-2">{properties?.address}</h6>
        <h6 className="mb-2">
          {properties?.get_in}: <span>{properties?.get_in_instruction}</span>
        </h6>
        <h6 className="mb-2">
          Rooms: <span>{properties?.number_of_rooms}</span>
        </h6>
        <h6 className="mb-2">
          Bathrooms: <span>{properties?.number_of_bathroom}</span>
        </h6>
        {hasAccess('accessFinalAmount', getUserRole()) && (
          <h6 className="mb-0">
            Value: <span>{formatAmount(finalAmount) || 0}</span>
          </h6>
        )}
      </div>

      {cleaningCancelRequestShow && (
        <div className="common_card_div status-div">
          <div className="form-header">
            <Alert color="warning">Do you want to add canclellation fees to the cleaner?</Alert>
          </div>
          <div className="multi_btn_div">
            <button type="button" className="btn btn-success common-field-btn w-100 btn-small" onClick={() => onAcknowledgeCleaningCancel(true)}>
              Approved
            </button>
            <button type="button" className="btn common-outline-btn w-100 btn-small" onClick={() => onAcknowledgeCleaningCancel(false)}>
              Decline
            </button>
          </div>
        </div>
      )}

      {isCleanningCancelByCleaner && (
        <div className="common_card_div status-div">
          <h6 className="mb-2">Clean Place Photos</h6>
          <CleaningPlacePhoto scheduledPropertiesComplete={scheduledPropertiesComplete?.cleaningData?.images} column={2} />
        </div>
      )}

      {viewLogVisiable && (
        <div className="multi_btn_div modal-button-group">
          <button type="submit" className="btn btn-primary common-field-btn sky_btn" onClick={() => onRedirectViewLog()}>
            View Log
          </button>
        </div>
      )}
    </div>
  )
}
export default CancelModalContent
